import { render, staticRenderFns } from "./gcjp_xqy.vue?vue&type=template&id=22ae7ab1&scoped=true&"
import script from "./gcjp_xqy.vue?vue&type=script&lang=js&"
export * from "./gcjp_xqy.vue?vue&type=script&lang=js&"
import style0 from "./gcjp_xqy.vue?vue&type=style&index=0&id=22ae7ab1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ae7ab1",
  null
  
)

export default component.exports